export enum PointTypes {
  DefaultPointType = 'defaultPoint',
  EarthmovingPointType = 'earthmovingPoint',
  StabilizationPointType = 'stabilizationPoint'
}